<template>
  <el-dialog title="添加成交客户" :visible.sync="show" width="690px" :close-on-click-modal="false" :before-close="closeDialog">
    <div class="tips">
      <p><i class="el-icon-warning"></i><i style="color:#333333;margin-right:0;font-size:13px">温馨提示：</i>请添加成交企业全称才可为您精准推荐数据</p>
      <!-- <p></p> -->
    </div>
    <div class="searchBlock">
      <el-autocomplete popper-class="recommend-head-autocomplete" clearable :placeholder="placeholder" :maxlength="50" size="small" v-model.trim="inputValue" :fetch-suggestions="querySearch"
        @input="changeInput">
        <el-button slot="suffix" :loading="loading" type="dialog-confirm" size="small" class="fr" @click="addTable" :disabled="addDisabled">添加</el-button>
        <template slot-scope="{ item }">
          <div class="name" v-html="item.name"></div>
          <!-- <span class="addr">{{ item.name }}</span> -->
        </template>
      </el-autocomplete>
    </div>
    <div class="tableMain">
      <div class="title">已添加</div>
      <el-table class="companyList" :data="companyList" style="width: 100%" max-height="320" v-loading='waiting'>
        <el-table-column label="公司" width="557" prop="name" :resizable="false"></el-table-column>
        <el-table-column label="操作" width="93" header-align="center" :resizable="false">
          <template slot-scope="scope">
            <div class="delete pointer tac" @click="handleDelete(scope.$index, scope.row)">删除</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="searchWith">
        <i class="el-icon-question" :title='title1'></i>根据搜索推荐<el-switch v-model="searchRecommend" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </div>
      <div class="searchWith">
        <i class="el-icon-question" :title='title2'></i>根据收藏推荐<el-switch v-model="starRecommend" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </div> -->
      <div>
        <div class="title">关系选择</div>
        <div class="selectBox fx-s-base">
          <div class="mr-16">供应链关系</div>
          <el-checkbox-group v-model="supplySelected">
            <el-checkbox v-for="(item,index) in supplyList" style="width: 80px;" :key="index" :label="item.value">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </div>

        <div class="selectBox fx-s-base">
          <div class="mr-16">股权链关系</div>
          <el-checkbox-group v-model="stockRightSelected">
            <el-checkbox v-for="(item,index) in stockRightList" style="width: 80px;" :key="index" :label="item.value">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </div>

      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="closeDialog">取消</el-button> -->
      <el-button type="dialog-confirm" w88 @click="submit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { clientList, clientAdd, clientDelete, associationSubmit, getByName } from '../../views/clue/api/newClueApi'
export default {
  name: '',
  props: {
    value: ''
  },
  data() {
    return {
      show: true,
      word: '',
      inputValue: '',
      placeholder: '',

      lastSearch: '',
      lastSearchArr: [],



      searchRecommend: true,
      starRecommend: true,
      title1: '根据历史搜索关键词进行推荐',
      title2: '根据收藏企业进行推荐',

      waiting: false,

      companyList: [],
      loading: false,
      addDisabled: false,
      hid: '',//HID

      supplySelected: [],
      supplyList: [
        { label: '供应商', value: '1' },
        { label: '客户', value: '2' },
      ],
      stockRightSelected: [],
      stockRightList: [
        { label: '股东', value: '3' },
        { label: '对外投资', value: '4' },
      ],
      submitId: ''

    }
  },
  created() {
    this.getCompanyList()
  },
  methods: {
    async submit() {
      await associationSubmit({
        type: [...this.supplySelected, ...this.stockRightSelected].join(','),
        id: this.submitId
      })
      this.$emit('change')
      this.closeDialog()
      const { recommendList, getTransactionCompanyNum } = this.$parent
      if (recommendList && getTransactionCompanyNum) {
        recommendList()
        getTransactionCompanyNum()
      }
    },
    changeVisible(show) {
      this.word = ''
      this.closeDialog()
    },
    closeDialog() {
      this.$emit('input')
    },
    async addTable() {
      // 获取公司对应的HID
      this.lastSearchArr.forEach(v => {
        if (v.value == this.inputValue) {
          this.hid = v.hid
        }
      })
      if (this.inputValue) {
        this.waiting = true
        this.loading = true
        // if (this.companyList.length < 5) {
        // 重复添加 后端返回511 使用try 防止控制台报错
        try {
          const res = await clientAdd({ name: this.inputValue, hid: this.hid })
          this.$message.success('添加成功')
          this.inputValue = ''
          this.lastSearch = ''
          this.lastSearchArr = []
          this.getCompanyList()
        } catch (err) {
        } finally {
          this.waiting = false
          this.loading = false
        }
        // } else {
        //   this.$message.warning('最多添加5个成交企业')
        // }

      } else {
        this.$message.warning('请输入成交客户名称')
      }
    },
    async handleDelete(index, row) {
      this.waiting = true
      const res = await clientDelete({ id: row.id })
      await this.getCompanyList()
      this.waiting = false
    },
    async getCompanyList() {
      this.waiting = true
      const res = await clientList()
      this.submitId = res.data.id
      this.companyList = res.data.list
      //   <el-checkbox-group v-model="supplySelected">
      //     <el-checkbox v-for="(item,index) in supplyList" style="width: 80px;" :key="index" :label="item.label"></el-checkbox>
      //   </el-checkbox-group>
      // </div>

      // <div class="selectBox fx-s-base">
      //   <div class="mr-16">股权链关系</div>
      //   <el-checkbox-group v-model="stockRightSelected">
      if (res.data.type) {
        const relation = res.data.type.split(',')
        this.supplySelected = relation.filter(e => e <= 2)
        this.stockRightSelected = relation.filter(e => e > 2)
      }
      this.waiting = false
    },


    async getByName(name) {
      const res = await getByName({ name })

      return res.data.map(e => {
        return {
          name: e.companyName,
          value: e.unlabeledCompanyName,
          hid: e.hid
        }
      })
    },
    async querySearch(queryString, cb) {
      if (queryString.length > 1) {
        if (this.lastSearch !== this.inputValue) {
          this.lastSearch = this.inputValue
          const res = await this.getByName(queryString)
          this.lastSearchArr = res
        }
      } else {
        this.lastSearch = this.inputValue
        this.lastSearchArr = []

      }
      cb(this.lastSearchArr)
    },
    // 输入框内容
    changeInput(val) {
      let flag = 0
      this.lastSearchArr.forEach(v => {
        v.name = v.name.replace(/<[^>]+>/g, '')
        if (v.value == val) {
          flag++
        }
      });
      if (flag == 0) {
        this.addDisabled = true
      } else {
        this.addDisabled = false
      }
    },

  }
}
</script>

<style lang='scss' rel='stylesheet/scss' scoped>
/deep/.el-dialog__header {
  // background: linear-gradient(45deg, #2b67e3 15%, #4eb7f8 100%);
  height: 42px;
  background: #fbfbfb;
  // border: 1px solid #000;
  padding: 0px 24px;
  box-sizing: border-box;
  .el-dialog__title {
    // font-size: 24px;
    // font-weight: 500;
    font-weight: 600;
    color: #666666;
    font-size: 14px;
    line-height: 42px;
  }
  .el-dialog__headerbtn {
    right: 15px;
    .el-dialog__close {
      font-size: 20px;
      width: 24px;
      height: 24px;
    }
  }
}
/deep/.el-dialog__body {
  padding: 0;
  padding-top: 16px;
}
.tips {
  padding: 0px 10px;
  margin: 0px 24px 24px;
  box-sizing: border-box;
  background: rgba(237, 255, 237, 0.5);
  border-radius: 4px;
  border: 1px solid #caefdc;
  p {
    line-height: 34px;
    height: 34px;
    font-size: 13px;
    font-weight: 400;
    color: #8c8c8c;
    > i {
      // color: #1a90ff;
      color: #30bf78;
      margin-right: 10px;
      vertical-align: middle;
      &.el-icon-warning:before {
        font-size: 16px;
      }
    }
    &:nth-child(2) {
      padding-left: 20px;
    }
  }
}
.searchBlock {
  padding: 0px 24px 23px;
  border-bottom: 1px solid #f2f2f2;
  /deep/.el-autocomplete {
    width: 100%;
  }
  /deep/ .el-input {
    .el-input__suffix {
      right: 0;
      height: 36px;
    }
    .el-input__inner {
      background-color: inherit;
      padding-right: 75px;
      height: 36px;
      box-shadow: none;
      &:hover,
      .el-input__inner:focus {
        border-color: #e8e8f0;
      }
    }
    .el-button {
      // border-radius: 0 4px 4px 0;
      border-radius: 4px;
      height: 36px;
    }
    .el-button--small {
      padding: 0px 15px;
      height: 36px;
      // line-height: 36px;
    }
    .el-input__icon {
      margin-top: 3px;
    }
  }
}

.tableMain {
  padding: 14px 24px 36px;
  box-sizing: border-box;
  .title {
    margin: 10px 0;
    font-weight: bold;
    color: #333333;
    font-size: 14px;
  }
  .companyList {
    margin-bottom: 10px;
  }
  .searchWith {
    font-size: 12px;
    > i {
      color: #4181ff;
      margin: 0 5px;
    }
    /deep/.el-switch {
      transform: scale(0.6);
      top: -2px;
    }
  }
}
::v-deep {
  .searchBlock {
    .el-input__inner:focus {
      border-color: #e8e8f0;
    }
  }
  .el-table {
    th.el-table__cell.is-leaf {
      background: #f7f7fa;
    }
    tr {
      height: 50px;
      &.el-table__row {
        .cell {
          font-size: 13px;
          line-height: 15px;
        }
        td {
          &:nth-of-type(1) {
            .cell {
              padding-left: 14px;
            }
          }
          &:nth-of-type(2) {
            .cell {
              .delete {
                color: rgb(80, 136, 255);
                font-size: 13px;
              }
            }
          }
        }
      }
    }
    .el-table_1_column_1 {
      padding-left: 16px;
      box-sizing: border-box;
    }
    .el-table_1_column_2 {
      text-align: left;
      .cell {
        padding-left: 0;
        .delete {
          //  color: #5088FF;
          color: rgb(80, 136, 255);
          text-align: left;
          font-size: 13px;
        }
      }
    }
    thead {
      height: 48px;
      tr th.el-table__cell {
        height: 48px;
        .cell {
          height: 47px;
          font-size: 14px;
        }
      }
    }
    &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
      background-color: #fafafd;
    }
  }
  .el-dialog__footer {
    border-top: none;
    .dialog-footer {
      .el-button.is-w88 {
        padding-top: 0;
        padding-bottom: 0;
        height: 32px;
      }
    }
  }

  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    position: absolute;
  }
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #bbbeca;
    border-radius: 10px;
    height: 51%;
    border: 2px solid transparent;
  }
  .el-table--scrollable-y
    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: #fff;
  }
  .el-table--scrollable-y
    .el-table__body-wrapper::-webkit-scrollbar-thumb:active {
    border: 0;
    border-radius: 0;
    background-color: #fff;
  }
  .el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: hidden;
  }
  .has-gutter {
    .el-table__cell {
      &.gutter {
        display: none;
        width: 0 !important;
      }
    }
    tr {
      height: 48px !important;
    }
  }
}
</style>
